import axios from "axios";

export interface StudentRow {
  studentId: string;
  admissionNumber: string;
  scholarNumber: string | null;
  studentName: string;
  class: string;
  section: string;
  assignedHouse: string | null;
}

export interface HouseItem {
  id: string;
  name: string;
  code: string;
  color?: string | null;
}

export const studentHouseApi = {
  getStudents: async (filters: { academicSessionId: string; classId?: string; sectionId?: string }) => {
    const res = await axios.get<StudentRow[]>("/scholar-register/student-house/students", { params: filters });
    return res.data;
  },
  getHouses: async () => {
    const res = await axios.get<HouseItem[]>("/scholar-register/student-house/houses");
    return res.data;
  },
  assign: async (payload: {
    studentId: string;
    houseId: string;
    academicSessionId: string;
    classId: string;
    sectionId: string;
    assignedDate?: string;
  }) => {
    const res = await axios.post("/scholar-register/student-house", payload);
    return res.data;
  },
  update: async (id: string, payload: { houseId?: string; assignedDate?: string }) => {
    const res = await axios.patch(`/scholar-register/student-house/${id}`, payload);
    return res.data;
  },
  remove: async (id: string) => {
    const res = await axios.delete(`/scholar-register/student-house/${id}`);
    return res.data;
  },
};
